const normalizeOptionalPackaging = ({ label, quantity, price } = {}) => {
  const normalizedLabel = String(label || "").trim();
  const hasPrice = price !== "" && price !== null && price !== undefined;
  const numericPrice = hasPrice ? Number(price) : null;

  if (!normalizedLabel && !hasPrice) {
    return { packaging: null, costPrice: null };
  }
  if (!normalizedLabel || !hasPrice || !Number.isFinite(numericPrice) || numericPrice <= 0) {
    throw new Error("Complétez le conditionnement.");
  }

  const numericQuantity = Number(quantity);
  if (!Number.isInteger(numericQuantity) || numericQuantity <= 0) {
    throw new Error("La quantité du lot est invalide.");
  }

  return {
    packaging: {
      packaging_unit: normalizedLabel,
      packaging_qty: numericQuantity,
      purchase_price: numericPrice,
      is_default: 1,
    },
    costPrice: Math.round((numericPrice / numericQuantity) * 10000) / 10000,
  };
};

const findGeneralSupplierId = (suppliers = []) => {
  const general = (Array.isArray(suppliers) ? suppliers : []).find(
    (supplier) => String(supplier?.name || "").trim().toLowerCase() === "général" ||
      String(supplier?.name || "").trim().toLowerCase() === "general",
  );
  return general?.id || "";
};

module.exports = { findGeneralSupplierId, normalizeOptionalPackaging };
